import { all, takeEvery } from 'redux-saga/effects';
import { verifyPhoneRequestSagas } from './verifyPhoneRequestSagas';
import { EVerifyPhoneActionTypes } from '@cian/sms-validation-widget';
import { verifyPhoneRetrySendingSms } from './verifyPhoneRetrySendingSmsSagas';
import { verifyPhoneCloseModal } from './verifyPhoneCloseModal';

export function* verifyPhoneSagas() {
  yield all([
    takeEvery(EVerifyPhoneActionTypes.REQUEST_VERIFY_PHONE_START, verifyPhoneRequestSagas),
    takeEvery(EVerifyPhoneActionTypes.REQUEST_RETRY_SENDING_SMS_START, verifyPhoneRetrySendingSms),
    takeEvery(EVerifyPhoneActionTypes.CLOSE_VERIFY_PHONE_MODAL, verifyPhoneCloseModal),
  ]);
}
